import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiService, JwtService } from '@app/core';

@Component({
  selector: 'app-beneficiary',
  templateUrl: './beneficiary.component.html',
  styleUrls: ['./beneficiary.component.css']
})
export class BeneficiaryComponent implements OnInit {
  @Output() activeIdString: EventEmitter<string> = new EventEmitter<string>();
  constructor(private apiService: ApiService,
    private jwtService: JwtService) { }
  beneficiaryName: string;
  currentParticipantID: String;

  ngOnInit() {
    this.activeIdString.emit('beneficiary');
    //this.currentParticipantID = this.jwtService.getParticipantId();
    this.getBeneficiaryData();
  }
  getBeneficiaryData() {
    const data = {};
    // const params = { "participantId": this.currentParticipantID };
    return this.apiService.get("/beneficiary").subscribe(
      data => {
        this.beneficiaryName = data.data.participantVO.beneficiaryName;
      }
    );
  }
}
